<template>
  <div class="checkbox-container" style="position: relative">
    <label class="el-checkbox">
      <span class="el-checkbox__input" :class="{ 'is-checked': visible }">
        <span class="el-checkbox__inner"></span>
        <input
          @change="changeCheckBox"
          type="checkbox"
          aria-hidden="false"
          class="el-checkbox__original"
          value
        />
      </span>
      <div class="el-checkbox__label">
        <div class="">我同意<a @click="showTip" class="link">《个人信息保护声明》</a><a @click="policy" class="link">《个人信息授权声明》</a></div>
        <p class="des">您的个人资料有可能会提交至林肯厂商的授权经销商或汽车之家客服，与您进一步沟通试驾、购车等事宜。</p>
      </div>
    </label>
  </div>
</template>
<script>
import { goUrl } from "@/utils/hybird";
import policy from './dialog/policy/index'
export default {
  props: ["value"],
  data() {
    return {
      visible: false,
    };
  },
  created() {
    this.visible = this.value;
  },
  methods: {
    goUrl(url, linkId) {
      goUrl(url, linkId);
    },
    showTip(){
      //policy();
      location.href = 'https://www.lincoln.com.cn/privacy/';
    },
    policy,
    changeCheckBox() {
      this.visible = !this.visible;
      this.$emit("input", this.visible);
    },
  },
};
</script>
<style lang="less" scoped="true">
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.checkbox-container {
  display: grid;
  width: 100%;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
  grid-template-columns: 50px auto;
  user-select: none;
  * {
    user-select: none;
  }
}
.tipBox {
  height: 20px;
  position: relative;
  z-index: 20;
  left: 20px;
  width: 100px;
}
.el-checkbox {
  color: #1c3855;
  font-weight: bold;
  font-size: 12px;
  position: relative;
  cursor: pointer;
  display: flex;
  width: 300px;
  user-select: none;
  line-height: 24px;
  text-align: left;
}
.el-checkbox__input {
  cursor: pointer;
  outline: none;
  display: inline-block;
}
.link{
  color:#bc7031;
}
.el-checkbox__inner {
  display: block;
  position: relative;
  border-radius: 2px;
  width: 14px;
  height: 14px;
  background:url(./check.png) no-repeat;
  background-size:100% auto;
  z-index: 1;
  top: 1px;
  right: 5px;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-image:url(./checkActive.png);
}
.el-checkbox__input.is-checked .el-checkbox__inner:after {
  transform: rotate(45deg) scaleY(1);
}
.el-checkbox__original {
  opacity: 0;
  outline: none;
  position: absolute;
  margin: 0;
  width: 0;
  height: 0;
  z-index: -1;
}
.des{
  font-size: 10px;
  color:#999;
}
.el-checkbox__label {
  display: inline-block;
  line-height: 19px;
}
</style>
